import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-glossary',
  templateUrl: './glossary.component.html',
})
export class GlossaryComponent {
  @Input() print: boolean;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/glossary/glossary.component.ts